/** Shared with the CMS. Optional choices override only the selected header's presentation. */
export type MenuPanelWidth = "small" | "medium" | "wide";
export type MenuHeaderKind =
  | "standard"
  | "transparent"
  | "floating"
  | "classic";
export interface MenuPresentation {
  kind: MenuHeaderKind;
  drawerWidth: string;
  logoHeight?: string;
  maxWidth?: string;
  solid?: boolean;
}
export function menuPanelWidth(
  kind: MenuHeaderKind,
  config: Record<string, any>,
  choice?: MenuPanelWidth,
): string {
  const base =
    kind === "floating" && typeof config.floating?.drawerWidth === "string"
      ? config.floating.drawerWidth
      : kind === "floating"
        ? "400px"
        : "380px";
  if (!choice || choice === "medium") return base;
  const factor = choice === "small" ? 320 / 380 : 520 / 380;
  const px = /^(\d+(?:\.\d+)?)px$/.exec(base);
  return px
    ? `${Math.round(Number(px[1]) * factor)}px`
    : `calc((${base}) * ${factor})`;
}
export function headerMenuPresentation(
  config: Record<string, any>,
): MenuPresentation {
  const kind: MenuHeaderKind =
    config.type === "TransparentHeader"
      ? "transparent"
      : config.type === "FloatingHeader"
        ? "floating"
        : config.type === "ClassicHeader"
          ? "classic"
          : "standard";
  const stored = config.menu?.panelWidth;
  const width = ["small", "medium", "wide"].includes(stored)
    ? (stored as MenuPanelWidth)
    : undefined;
  return {
    kind,
    drawerWidth: menuPanelWidth(kind, config, width),
    ...(kind === "classic"
      ? {
          logoHeight: config.classic?.logoHeight || "90px",
          maxWidth: config.classic?.maxWidth || "1310px",
        }
      : {}),
    solid:
      kind === "standard" || (kind === "transparent" && !!config.isVisible),
  };
}
